import { listAllByAuthUser, create, update } from 'src/repositories/campaign.repository';

/**
 * Action Types
 */
export const CAMPAIGNS_LOADING = 'CAMPAIGNS_LOADING';
export const CAMPAIGNS_LOADED = 'CAMPAIGNS_LOADED';
export const CAMPAIGN_CREATING = 'CAMPAIGN_CREATING';
export const CAMPAIGN_CREATED = 'CAMPAIGN_CREATED';
export const CAMPAIGN_UPDATING = 'CAMPAIGN_UPDATING';
export const CAMPAIGN_UPDATED = 'CAMPAIGN_UPDATED';

/**
 * Action Creators
 */

export const loadingCampaigns = isLoading => ({
    type: CAMPAIGNS_LOADING,
    payload: isLoading,
});

export const loadedCampaigns = campaigns => ({
    type: CAMPAIGNS_LOADED,
    payload: campaigns,
});

export const creatingCampaign = isLoading => ({
    type: CAMPAIGN_CREATING,
    payload: isLoading,
});

export const campaignCreated = campaign => ({
    type: CAMPAIGN_CREATED,
    payload: campaign,
});

export const updatingCampaign = isLoading => ({
    type: CAMPAIGN_UPDATING,
    payload: isLoading,
});

export const campaignUpdated = campaign => ({
    type: CAMPAIGN_UPDATED,
    payload: campaign,
});

/**
 * Actions
 */


/**
 * Load all campaigns by authenticated user
 */
export const loadCampaigns = () => (dispatch) => {
    dispatch(loadingCampaigns(true));
    return listAllByAuthUser()
        .then(({ data }) => {
            dispatch(loadedCampaigns(data));
        })
        .finally(() => {
            dispatch(loadingCampaigns(false));
        });
};

/**
 * Create new campaign
 */
export const createCampaign = params => (dispatch) => {
    dispatch(creatingCampaign(true));
    return create(params)
        .then(({ data }) => {
            dispatch(campaignCreated(data));
            return data;
        })
        .finally(() => {
            dispatch(loadingCampaigns(false));
        });
};

/**
 * Update campaign
 */
export const updateCampaign = (id, params) => (dispatch) => {
    dispatch(updatingCampaign(true));
    return update(id, params)
        .then(({ data }) => {
            dispatch(campaignUpdated(data));
        })
        .finally(() => {
            dispatch(updatingCampaign(false));
        });
};
